import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import clipboard from 'clipboard-js';
import ContactDetailsBlock from 'containers/ContactDetailsBlock/ContactDetailsBlockContainer';
import Button from 'components/Button/Button';
import LockedMeetingTooltip from 'components/Tooltip/LockedMeetingTooltip';
import lsConfig from 'utils/global-config';
import { ADD_PARTICIPANT_DRAWER } from 'constants/AddParticipantDrawer';
import _compact from 'lodash/compact';
import logger from 'utils/logger';
import classes from './CallDetails.module.scss';

export class CallDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detailsAreCopied: false,
    };
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (!nextProps.contact) {
      this.props.closeInCallDrawer();
    }
  }

  copyCallDetails = async () => {
    try {
      const invitation = await this.props.getInviteForExtension();
      clipboard.copy({
        'text/plain': invitation.body
      });

      this.setState({
        detailsAreCopied: true
      });
    } catch (err) {
      logger.error(`Unable to copy invitation: ${err}`);
    }
  };

  handleEmailClick = async () => {
    try {
      const mailto = await this.props.getInviteMailLinkForExtension();
      // Create and click email link
      const element = document.createElement('a');
      element.setAttribute('href', mailto);

      element.style.display = 'none';
      document.body.appendChild(element);

      lsConfig.skipTimeOnBeforeUnload(1000);
      element.click();

      document.body.removeChild(element);
    } catch (err) {
      logger.error(`Unable to create mailto link: ${err}`);
    }
  };

  render() {
    const {
      contact,
      isGuest,
      isLockedByModerator,
      isVisible,
      onOpenDrawer
    } = this.props;
    const containerClasses = _compact([
      classes.container,
      isVisible ? '' : classes.hiddenDrawer
    ]).join(' ');

    return (
      <div className={containerClasses}>
        <header>
          <h6>
            <FormattedMessage
              id="components.inCall.callDetailsDrawer.title"
              defaultMessage="Call Details"
            />
          </h6>
        </header>
        <div className={classes.details}>
          <ContactDetailsBlock
            contact={contact}
            hideOwner
          />
          {!isGuest && (
            <Button
              onClick={this.copyCallDetails}
              kind={this.state.detailsAreCopied ? 'success' : 'secondary'}
              size="small"
              style={{ display: 'block', minHeight: 32, marginTop: 15, minWidth: 'initial', width: '100%' }}
              dataAttrs={{ 'data-testid': 'call-details-copy-btn' }}
            >
              <FormattedMessage
                id="components.inCall.callDetailsDrawer.copyCallDetailsLabel"
                defaultMessage="Copy Call Details"
              />
            </Button>
          )}
        </div>
        {!isGuest && (
          <div className={classes.footer}>
            <Button
              onClick={this.handleEmailClick}
              kind="primary"
              size="small"
              style={{ display: 'block', minHeight: 32, marginTop: 5, minWidth: 'initial', width: '100%' }}
              dataAttrs={{ 'data-testid': 'call-details-invite-btn' }}
            >
              <FormattedMessage
                id="components.inCall.callDetailsDrawer.inviteByEmail"
                defaultMessage="Invite by Email"
              />
            </Button>
            <div className={classes.link}>
              {isLockedByModerator && <LockedMeetingTooltip />}
              <a
                disabled={isLockedByModerator}
                onClick={() => onOpenDrawer(ADD_PARTICIPANT_DRAWER)}
                data-testid="call-details-add-participant"
              >
                <FormattedMessage
                  id="components.inCall.callDetailsDrawer.addParticipant"
                  defaultMessage="Add a participant to the call"
                />
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}

CallDetails.propTypes = {
  closeInCallDrawer: PT.func,
  contact: PT.object,
  getInviteForExtension: PT.func,
  getInviteMailLinkForExtension: PT.func,
  isGuest: PT.bool,
  isLockedByModerator: PT.bool,
  isVisible: PT.bool,
  onOpenDrawer: PT.func
};

export default CallDetails;
